import moment from 'moment-timezone';
import each from 'lodash/each';
import cloneDeep from 'lodash/cloneDeep';
export const timeZones = [
    {
        text: 'UTC Universal Coordinated Time GMT',
        default_value: 0,
        moment_name: 'UTC',
        isDST: false,
    },
    {
        text: 'Europe London GMT+1:00',
        default_value: 0,
        moment_name: 'Europe/London',
        isDST: false,
    },
    {
        text: 'EET Eastern European Time GMT+2:00',
        default_value: -2,
        moment_name: 'Europe/Paris',
        isDST: false,
    },
    {
        text: 'EAT Eastern African Time GMT+3:00',
        default_value: -3,
        moment_name: 'Africa/Nairobi',
        isDST: false,
    },
    {
        text: 'MET Middle East Time GMT+3:30',
        default_value: -3.5,
        moment_name: 'Asia/Tehran',
        isDST: false,
    },
    {
        text: 'NET Near East Time GMT+4:00',
        default_value: -4,
        moment_name: 'Asia/Dubai',
        isDST: false,
    },
    {
        text: 'PLT Pakistan Lahore Time GMT+5:00',
        default_value: -5,
        moment_name: 'Asia/Dushanbe',
        isDST: false,
    },
    {
        text: 'IST India Standard Time GMT+5:30',
        default_value: -5.5,
        moment_name: 'Asia/Calcutta',
        isDST: false,
    },
    {
        text: 'BST Bangladesh Standard Time GMT+6:00',
        default_value: -6,
        moment_name: 'Asia/Dhaka',
        isDST: false,
    },
    {
        text: 'VST Vietnam Standard Time GMT+7:00',
        default_value: -7,
        moment_name: 'Asia/Ho_Chi_Minh',
        isDST: false,
    },
    {
        text: 'CTT China Taiwan Time GMT+8:00',
        default_value: -8,
        moment_name: 'Asia/Shanghai',
        isDST: false,
    },
    {
        text: 'JST Japan Standard Time GMT+9:00',
        default_value: -9,
        moment_name: 'Asia/Tokyo',
        isDST: false,
    },
    {
        text: 'ACT Australia Central Time GMT+9:30',
        default_value: -9.5,
        moment_name: 'Australia/Adelaide',
        isDST: false,
    },
    {
        text: 'AET Australia Eastern Time GMT+10:00',
        default_value: -10,
        moment_name: 'Australia/Sydney',
        isDST: false,
    },
    {
        text: 'SST Solomon Standard Time GMT+11:00',
        default_value: -11,
        moment_name: 'Pacific/Bougainville',
        isDST: false,
    },
    {
        text: 'NST New Zealand Standard Time GMT+12:00',
        default_value: -12,
        moment_name: 'Pacific/Fiji',
        isDST: false,
    },
    {
        text: 'MIT Midway Islands Time GMT-11:00',
        default_value: 11,
        moment_name: 'Pacific/Midway',
        isDST: false,
    },
    {
        text: 'HST Hawaii Standard Time GMT-10:00',
        default_value: 10,
        moment_name: 'Pacific/Honolulu',
        isDST: false,
    },
    {
        text: 'AST Alaska Standard Time GMT-9:00',
        default_value: 9,
        moment_name: 'America/Adak',
        isDST: false,
    },
    {
        text: 'PST Pacific Standard Time GMT-8:00',
        default_value: 8,
        moment_name: 'America/Los_Angeles',
        isDST: false,
    },
    {
        text: 'MST Mountain Standard Time GMT-7:00',
        default_value: 7,
        moment_name: 'MST',
        isDST: false,
    },
    {
        text: 'CST Central Standard Time GMT-6:00',
        default_value: 6,
        moment_name: 'US/Mountain',
        isDST: false,
    },
    {
        text: 'EST Eastern Standard Time GMT-5:00',
        default_value: 5,
        moment_name: 'EST5EDT',
        isDST: false,
    },
    {
        text: 'PRT Puerto Rico and US Virgin Islands Time GMT-4:00',
        default_value: 4,
        moment_name: 'America/Puerto_Rico',
        isDST: false,
    },
    {
        text: 'AGT Argentina Standard Time GMT-3:00',
        default_value: 3,
        moment_name: 'America/Buenos_Aires',
        isDST: false,
    },
    {
        text: 'CAT Central African Time GMT-1:00',
        default_value: 1,
        moment_name: 'Atlantic/Cape_Verde',
        isDST: false,
    },
];
export const getTimeZones = () => {
    const now = moment();
    // let displayValue
    const timezonesInstance = cloneDeep(timeZones);
    each(timezonesInstance, function (tz) {
        // displayValue = now.tz(tz.moment_name).format('Z')
        tz.isDST = moment.tz(now.format(), tz.moment_name).isDST();
        tz.value = tz.default_value;
        if (tz.isDST) {
            tz.default_value = tz.value;
            tz.value -= 1;
            // displayValue = displayValue.replace(Math.abs(tz.default_value), tz.value)
            tz.text = tz.text.split('GMT')[0] + 'GMT';
            tz.text = tz.text.replace(/\+-/, '');
            tz.text += tz.value > 0 ? '-' : '+';
            tz.text += Math.abs(tz.value).toFixed(2).replace('.', ':');
            tz.text += ' DST';
        }
    });
    return timezonesInstance;
};
//# sourceMappingURL=timezone.js.map